<template >
	<div class="grid-layout">
		<div class="grid-list">
			<div v-for="(item,index) in list" :key="index" class="item">
				<div @click="toArticle(item)">
					<el-image :src="(item.extraJson&&item.extraJson.avatar)||defaultAvatar" class="avatar"
						fit='cover' />
					<div class="item-name">
						<span style="font-weight:bold;font-size:16px;vertical-align: middle;">{{item.extraJson?item.extraJson.name:''}}</span>
						<el-tag size='mini' v-if="item.status.code!=1" style="margin-left:10px">

							<!-- 优先显示发布状态， -->
							{{item.status.code==1?item.status.description:item.approveStatus && item.approveStatus.code>0?item.approveStatus.description:item.status.description}}
						</el-tag>

					</div>
					<!-- <div style="font-weight:bold;font-size:16px;margin:6px 0">
					</div> -->
					<div style="margin-bottom:6px;">{{item.extraJson?item.extraJson.date:''}}入党</div>
					<div style="text-overflow: ellipsis;overflow:hidden">
						{{item.extraJson?item.extraJson.description:''}}
					</div>
				</div>
				<div style="margin-top:5px;width:100%">
					<template v-if="currentUser.id==item.author.id">
						<el-button type="text" style="padding:2px" size='mini' v-if="item.status.code!=1"
							@click="toEditor(item)">修改</el-button>
						<el-button type="text" size='mini' style="padding:2px"
							v-if="item.status.code==0 && (!item.approveStatus || item.approveStatus.code==3) "
							@click="release(item)">发布</el-button>
						<el-button type="text" size='mini' style="padding:2px"
							v-if="item.status.code!=1 && item.approveStatus && [1,2].includes(item.approveStatus.code)"
							@click="revoke(item)">撤回
						</el-button>
						<el-button type="text" size='mini' style="padding:2px"
							v-if="item.status.code==0 && (!item.approveStatus||item.approveStatus.code==3)"
							@click="remove(item)">删除
						</el-button>
					</template>
				</div>
			</div>
		</div>
		<el-pagination v-if="list.length>0" background layout="prev, pager, next" :page-size="filters.pageSize"
			:current-page="filters.pageNum" :total="total" @current-change="getContentList" />
	</div>
</template>
<script>
	import articleListMixin from './article-list-mixin'
	import { mapState } from 'vuex'

	export default {
		mixins: [articleListMixin],
		data() {
			return {

			}
		},
		computed: {
			...mapState('common', ['defaultAvatar'])
		},
		methods: {


		},
		mounted() {
			this.filters.pageSize = 9
		},
	}
</script>

<style lang="scss" scoped>
	.item {
		width: 253px;
		overflow: hidden;
		text-align: center;
		padding: 5px;
		margin-bottom: 15px;
		cursor: pointer;
	}
	.avatar {
		border-radius: 5px;
		width: 140px;
		height: 160px;
		display: inline-block;
		& /deep/ .el-image__inner {
			object-position: top;
		}
	}
	.grid-list {
		display: flex;
		flex-wrap: wrap;
		width: 100%;
		font-size: 14px;
		margin-top: 20px;
		overflow: auto;
	}
	.grid-layout {
		& /deep/ .el-pagination {
			display: flex;
			justify-content: right;
			float: none;
		}
	}
	.item-name{
		margin: 6px 0;
		
	}
</style>


// WEBPACK FOOTER //
// src/views/party-build/article-grid-layout.vue